import React from 'react'

const Text = ({ children, huge, large, bold, center, className, style }) => {
  return <div className={`Text ${huge && 'huge'} ${large && 'large'} ${bold && 'bold'} ${center && 'center'} ${className}`} style={style}>
    {children}
  </div>
}

export default Text
